import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { resetState } from '../../../store/actions';
import { RootState } from '../../../store/store';

export interface ScanRequestState {
  activeScanRequestId: string | null;
  tempScanRequestId: string | null;
  isScanRequestPreviewOpen: boolean;
  selectedScanRequestIds: string[];
}

const initialState: ScanRequestState = {
  activeScanRequestId: null,
  tempScanRequestId: null,
  isScanRequestPreviewOpen: false,
  selectedScanRequestIds: [],
};

const scanRequestsSlice = createSlice({
  name: 'scanRequests',
  initialState,
  reducers: {
    setActiveScanRequestId: (state, { payload }: PayloadAction<string | null>) => {
      state.activeScanRequestId = payload;
    },
    setTempScanRequestId: (state, { payload }: PayloadAction<string | null>) => {
      state.tempScanRequestId = payload;
    },
    setIsScanRequestPreviewOpen: (state, { payload }: PayloadAction<boolean>) => {
      state.isScanRequestPreviewOpen = payload;
    },
    setSelectedScanRequestIds: (state, { payload }: PayloadAction<string[]>) => {
      state.selectedScanRequestIds = payload;
    },
  },
  extraReducers: builder => {
    builder.addMatcher(resetState.match, () => initialState);
  },
});

export const selectActiveScanRequestId = (state: RootState) => state.scanRequests.activeScanRequestId;
export const selectTempScanRequestId = (state: RootState) => state.scanRequests.tempScanRequestId;
export const selectIsScanRequestPreviewOpen = (state: RootState) => state.scanRequests.isScanRequestPreviewOpen;
export const selectSelectedScanRequestIds = (state: RootState) => state.scanRequests.selectedScanRequestIds;

export const { setActiveScanRequestId, setTempScanRequestId, setIsScanRequestPreviewOpen, setSelectedScanRequestIds } =
  scanRequestsSlice.actions;

const scanRequestsReducer = scanRequestsSlice.reducer;

export default scanRequestsReducer;
